// assets/htm-courses.js — HTM Academy Kurse (Course Browser + Player + Admin)
(function(){
'use strict';
var PROXY='https://htm-proxy.vercel.app';
function uid(){return localStorage.getItem('htm_uid')||'';}
function email(){return localStorage.getItem('htm_email')||'';}
function plan(){return localStorage.getItem('htm_plan')||'free';}
function userName(){return localStorage.getItem('htm_user_name')||'Member';}
function esc(s){var d=document.createElement('div');d.textContent=s;return d.innerHTML;}
function fmtDur(s){if(!s)return'';var m=Math.floor(s/60);return m>=60?Math.floor(m/60)+'h '+m%60+'m':m+'m';}

var _isAdmin=false,_courses=[],_progress={},_currentCourse=null,_initialized=false;

function api(action,body){
  return fetch(PROXY+'/api/xp',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+(localStorage.getItem('htm_session')||'')},body:JSON.stringify(Object.assign({action:action,uid:uid(),email:email()},body||{}))}).then(function(r){return r.json();});
}

// ── INIT ──
function init(){
  if(_initialized)return;_initialized=true;
  var v=document.getElementById('htmKurseView');
  if(!v)return;
  // Check admin from localStorage (set by community.js token fetch)
  var raw=localStorage.getItem('htm_admin');
  _isAdmin=raw==='true';
  // If not cached yet, fetch token to check admin status
  if(!raw&&uid()){
    fetch(PROXY+'/api/community',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+(localStorage.getItem('htm_session')||'')},body:JSON.stringify({action:'token',uid:uid(),email:email()})}).then(function(r){return r.json();}).then(function(d){
      if(d.ok){_isAdmin=!!d.admin;localStorage.setItem('htm_admin',_isAdmin?'true':'false');renderCourseList();}
    }).catch(function(){});
  }
  loadCourseList();
}

// ── COURSE LIST VIEW ──
function loadCourseList(){
  var v=document.getElementById('htmKurseView');
  if(!v)return;
  v.innerHTML='<div class="kr-wrap"><div class="kr-header"><div class="kr-title">Kurse</div>'+(_isAdmin?'<button class="kr-admin-btn" id="krNewCourse">+ Neuer Kurs</button>':'')+'</div><div class="kr-loading">Wird geladen...</div></div>';
  api('courses-list').then(function(d){
    if(!d.ok)return;
    _courses=d.courses||[];
    renderCourseList();
  }).catch(function(){
    v.querySelector('.kr-loading').textContent='Fehler beim Laden';
  });
}

function renderCourseList(){
  var v=document.getElementById('htmKurseView');
  if(!v)return;
  var html='<div class="kr-wrap"><div class="kr-header"><div class="kr-title">Kurse</div>'+(_isAdmin?'<button class="kr-admin-btn" onclick="htmCourseNew()">+ Neuer Kurs</button>':'')+'</div>';
  if(!_courses.length){
    html+='<div class="kr-empty">Noch keine Kurse verfügbar.</div>';
  } else {
    html+='<div class="kr-grid">';
    _courses.forEach(function(c){
      var pct=c.totalLessons?Math.round(c.completed/c.totalLessons*100):0;
      var lockHtml=c.locked?'<div class="kr-lock">🔒</div>':'';
      var bannerHtml=c.banner?'<div class="kr-card-banner"><img src="'+esc(c.banner)+'" alt=""></div>':'';
      html+='<div class="kr-card'+(c.locked?' locked':'')+'" onclick="htmCourseOpen(\''+esc(c.id)+'\')">'
        +lockHtml+bannerHtml
        +'<div class="kr-card-body">'
          +'<div class="kr-card-title">'+esc(c.title)+'</div>'
          +'<div class="kr-card-meta">'+c.totalLessons+' Lektionen · '+fmtDur(c.totalDuration)+'</div>'
          +(c.locked?'<div class="kr-card-upgrade">Plan-Upgrade nötig</div>':'<div class="kr-progress-bar"><div class="kr-progress-fill" style="width:'+pct+'%"></div></div><div class="kr-card-meta">'+pct+'% abgeschlossen</div>')
        +'</div>'
      +'</div>';
    });
    html+='</div>';
  }
  html+='</div>';
  v.innerHTML=html;
}

// ── COURSE DETAIL VIEW ──
window.htmCourseOpen=function(courseId){
  var c=_courses.find(function(x){return x.id===courseId;});
  if(c&&c.locked){return;}
  var v=document.getElementById('htmKurseView');
  if(!v)return;
  v.innerHTML='<div class="kr-wrap"><div class="kr-back" onclick="loadCourseList()">← Zurück</div><div class="kr-loading">Wird geladen...</div></div>';
  api('course-get',{courseId:courseId}).then(function(d){
    if(!d.ok){v.querySelector('.kr-loading').textContent=d.error||'Fehler';return;}
    _currentCourse=d.course;
    _progress=d.progress||{};
    renderCourseDetail();
  });
};

function renderCourseDetail(){
  var v=document.getElementById('htmKurseView');
  if(!v||!_currentCourse)return;
  var c=_currentCourse;
  var totalL=(c.modules||[]).reduce(function(s,m){return s+(m.lessons||[]).length;},0);
  var doneL=(c.modules||[]).reduce(function(s,m){return s+(m.lessons||[]).filter(function(l){return _progress[c.id+'/'+m.id+'/'+l.id];}).length;},0);
  var pct=totalL?Math.round(doneL/totalL*100):0;

  var bannerHtml=c.banner?'<div class="kr-detail-banner"><img src="'+esc(c.banner)+'" alt=""></div>':'';
  var html='<div class="kr-wrap">'
    +'<div class="kr-back" onclick="loadCourseList()">← Zurück</div>'
    +bannerHtml
    +'<div class="kr-detail-header">'
      +'<div><div class="kr-detail-title">'+esc(c.title)+'</div>'
      +'<div class="kr-detail-meta">'+totalL+' Lektionen · '+fmtDur((c.modules||[]).reduce(function(s,m){return s+(m.lessons||[]).reduce(function(s2,l){return s2+(l.duration||0);},0);},0))+' · '+doneL+' abgeschlossen</div></div>'
      +(_isAdmin?'<button class="kr-admin-btn" onclick="htmCourseEdit()">✏️</button>':'')
    +'</div>'
    +'<div class="kr-progress-bar lg"><div class="kr-progress-fill" style="width:'+pct+'%"></div></div>'
    +(c.description?'<div class="kr-desc">'+esc(c.description)+'</div>':'');

  var mods=c.modules||[];
  var singleModule=mods.length===1;
  mods.forEach(function(mod){
    var modDone=(mod.lessons||[]).filter(function(l){return _progress[c.id+'/'+mod.id+'/'+l.id];}).length;
    var modDur=(mod.lessons||[]).reduce(function(s,l){return s+(l.duration||0);},0);
    if(singleModule){
      // No accordion — show lessons directly
      html+='<div class="kr-module open">'
        +'<div class="kr-module-lessons" style="display:block;border-top:none;">';
    } else {
      html+='<div class="kr-module">'
        +'<div class="kr-module-header" onclick="this.parentElement.classList.toggle(\'open\')">'
          +'<span class="kr-module-arrow">▶</span>'
          +'<span class="kr-module-title">'+esc(mod.title)+'</span>'
          +'<span class="kr-module-count">'+fmtDur(modDur)+' · '+modDone+'/'+(mod.lessons||[]).length+'</span>'
        +'</div>'
        +'<div class="kr-module-lessons">';
    }
    var modPlans=mod.plans&&mod.plans.length?mod.plans:c.plans||[];
    var userPlan=plan()||'free';
    var modLocked=!_isAdmin&&modPlans.length>0&&!modPlans.includes(userPlan)&&!modPlans.includes('free');
    (mod.lessons||[]).forEach(function(les){
      var done=!!_progress[c.id+'/'+mod.id+'/'+les.id];
      if(modLocked){
        html+='<div class="kr-lesson locked">'
          +'<div class="kr-lesson-check">🔒</div>'
          +'<div class="kr-lesson-info">'
            +'<div class="kr-lesson-title">'+esc(les.title)+'</div>'
            +'<div class="kr-lesson-dur" style="color:var(--green);font-weight:600;">Upgrade auf Pro erforderlich</div>'
          +'</div>'
        +'</div>';
      } else {
        html+='<div class="kr-lesson'+(done?' done':'')+'" onclick="htmLessonOpen(\''+esc(c.id)+'\',\''+esc(mod.id)+'\',\''+esc(les.id)+'\')">'
          +'<div class="kr-lesson-check">'+(done?'✅':'○')+'</div>'
          +'<div class="kr-lesson-info">'
            +'<div class="kr-lesson-title">'+esc(les.title)+'</div>'
            +'<div class="kr-lesson-dur">'+fmtDur(les.duration)+'</div>'
          +'</div>'
          +'<div class="kr-lesson-play">▶</div>'
        +'</div>';
      }
    });
    html+='</div></div>';
  });
  html+='</div>';
  v.innerHTML=html;
}

// ── LESSON PLAYER VIEW ──
window.htmLessonOpen=function(courseId,moduleId,lessonId){
  if(!_currentCourse||_currentCourse.id!==courseId){
    api('course-get',{courseId:courseId}).then(function(d){
      if(!d.ok)return;
      _currentCourse=d.course;_progress=d.progress||{};
      renderLesson(courseId,moduleId,lessonId);
    });
  } else {
    renderLesson(courseId,moduleId,lessonId);
  }
};

function renderLesson(courseId,moduleId,lessonId){
  var v=document.getElementById('htmKurseView');
  if(!v||!_currentCourse)return;
  var mod=(_currentCourse.modules||[]).find(function(m){return m.id===moduleId;});
  if(!mod)return;
  var les=(mod.lessons||[]).find(function(l){return l.id===lessonId;});
  if(!les)return;
  var done=!!_progress[courseId+'/'+moduleId+'/'+lessonId];
  // Find prev/next lesson
  var allLessons=[];
  (_currentCourse.modules||[]).forEach(function(m){(m.lessons||[]).forEach(function(l){allLessons.push({m:m.id,l:l.id});});});
  var idx=allLessons.findIndex(function(x){return x.m===moduleId&&x.l===lessonId;});
  var prev=idx>0?allLessons[idx-1]:null;
  var next=idx<allLessons.length-1?allLessons[idx+1]:null;

  var videoHtml='';
  if(les.videoUrl){
    if(les.videoUrl.includes('cloudflarestream.com')||les.videoUrl.includes('iframe')){
      videoHtml='<iframe class="kr-video" src="'+esc(les.videoUrl)+'" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    } else if(les.videoUrl.includes('youtube.com')||les.videoUrl.includes('youtu.be')){
      var ytId=les.videoUrl.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
      videoHtml=ytId?'<iframe class="kr-video" src="https://www.youtube-nocookie.com/embed/'+ytId[1]+'" allow="accelerometer; autoplay; encrypted-media" allowfullscreen></iframe>':'';
    } else {
      videoHtml='<video class="kr-video" controls src="'+esc(les.videoUrl)+'"></video>';
    }
  }

  var html='<div class="kr-wrap">'
    +'<div class="kr-back" onclick="htmCourseOpen(\''+esc(courseId)+'\')">← '+esc(_currentCourse.title)+'</div>'
    +videoHtml
    +'<div class="kr-lesson-detail">'
      +'<div class="kr-lesson-detail-title">'+esc(les.title)+'</div>'
      +(les.description?'<div class="kr-lesson-detail-desc">'+esc(les.description)+'</div>':'')
      +'<div class="kr-lesson-actions">'
        +(done?'<button class="kr-btn done" disabled>✅ Abgeschlossen</button>':'<button class="kr-btn" id="krCompleteBtn" onclick="htmLessonComplete(\''+esc(courseId)+'\',\''+esc(moduleId)+'\',\''+esc(lessonId)+'\')">✓ Als abgeschlossen markieren</button>')
      +'</div>'
      +'<div class="kr-lesson-nav">'
        +(prev?'<button class="kr-nav-btn" onclick="htmLessonOpen(\''+esc(courseId)+'\',\''+esc(prev.m)+'\',\''+esc(prev.l)+'\')">← Vorherige</button>':'<span></span>')
        +(next?'<button class="kr-nav-btn" onclick="htmLessonOpen(\''+esc(courseId)+'\',\''+esc(next.m)+'\',\''+esc(next.l)+'\')">Nächste →</button>':'')
      +'</div>'
    +'</div>'
  +'</div>';
  v.innerHTML=html;
}

window.htmLessonComplete=function(courseId,moduleId,lessonId){
  var btn=document.getElementById('krCompleteBtn');
  if(btn){btn.disabled=true;btn.textContent='...';}
  api('course-complete',{courseId:courseId,moduleId:moduleId,lessonId:lessonId}).then(function(d){
    if(!d.ok){if(btn){btn.disabled=false;btn.textContent='✓ Als abgeschlossen markieren';}return;}
    _progress[courseId+'/'+moduleId+'/'+lessonId]=Date.now();
    if(btn){btn.className='kr-btn done';btn.textContent='✅ Abgeschlossen (+50 XP)';}
    if(d.xp&&d.xp.totalXP!=null){var c=JSON.parse(localStorage.getItem('htm_xp')||'{}');c.total=d.xp.totalXP;if(d.xp.level)c.level=d.xp.level.level;if(d.xp.level)c.name=d.xp.level.name;if(d.xp.level)c.progress=d.xp.level.progress;if(d.xp.level)c.next=d.xp.level.nextLevelXP;localStorage.setItem('htm_xp',JSON.stringify(c));}
    // XP toast
    var toast=document.createElement('div');
    toast.className='kr-xp-toast';
    toast.textContent='+50 XP';
    document.body.appendChild(toast);
    if(window.htmPlayXPSound)window.htmPlayXPSound(false);
    setTimeout(function(){toast.remove();},2500);
  });
};

// ── ADMIN: NEW COURSE ──
window.htmCourseNew=function(){
  var course={id:'',title:'',icon:'📚',description:'',plans:['basic','pro','scale'],modules:[]};
  renderCourseEditor(course,true);
};

// ── ADMIN: EDIT COURSE ──
window.htmCourseEdit=function(){
  if(!_currentCourse)return;
  renderCourseEditor(JSON.parse(JSON.stringify(_currentCourse)),false);
};

function renderCourseEditor(course,isNew){
  var v=document.getElementById('htmKurseView');
  if(!v)return;
  var html='<div class="kr-wrap">'
    +'<div class="kr-back" onclick="'+(isNew?'loadCourseList()':'renderCourseDetail()')+'">'+(isNew?'← Zurück':'← Abbrechen')+'</div>'
    +'<div class="kr-editor">'
      +'<div class="kr-ed-title">'+(isNew?'Neuer Kurs':'Kurs bearbeiten')+'</div>'
      +'<label class="kr-ed-label">ID (einmalig, keine Leerzeichen)</label>'
      +'<input class="kr-ed-input" id="krEdId" value="'+esc(course.id)+'" '+(isNew?'':'readonly')+' placeholder="z.B. ecom">'
      +'<label class="kr-ed-label">Titel</label>'
      +'<input class="kr-ed-input" id="krEdTitle" value="'+esc(course.title)+'" placeholder="Kurstitel">'
      +'<label class="kr-ed-label">Banner-Bild (URL, Querformat)</label>'
      +'<input class="kr-ed-input" id="krEdBanner" value="'+esc(course.banner||'')+'" placeholder="https://cdn.shopify.com/...">'
      +(course.banner?'<div class="kr-ed-banner-prev"><img src="'+esc(course.banner)+'" alt="Vorschau"></div>':'')
      +'<label class="kr-ed-label">Icon (Emoji, optional)</label>'
      +'<input class="kr-ed-input" id="krEdIcon" value="'+esc(course.icon||'')+'" placeholder="📚">'
      +'<label class="kr-ed-label">Beschreibung</label>'
      +'<textarea class="kr-ed-input" id="krEdDesc" rows="3" placeholder="Kursbeschreibung...">'+esc(course.description||'')+'</textarea>'
      +'<label class="kr-ed-label">Zugang (Plans)</label>'
      +'<div class="kr-ed-plans">'
        +['free','basic','member','pro','scale'].map(function(p){return '<label class="kr-ed-plan-cb"><input type="checkbox" value="'+p+'" '+(course.plans&&course.plans.includes(p)?'checked':'')+'> '+p+'</label>';}).join('')
      +'</div>'
      +'<div class="kr-ed-section-title">Module & Lektionen</div>'
      +'<div id="krEdModules"></div>'
      +'<button class="kr-admin-btn" onclick="htmEdAddModule()">+ Modul hinzufügen</button>'
      +'<div class="kr-ed-actions">'
        +'<button class="kr-btn save" onclick="htmEdSave()">💾 Speichern</button>'
        +(!isNew?'<button class="kr-btn delete" onclick="htmEdDelete(\''+esc(course.id)+'\')">🗑️ Kurs löschen</button>':'')
      +'</div>'
    +'</div>'
  +'</div>';
  v.innerHTML=html;
  window._edCourse=course;
  renderEditorModules();
}

function renderEditorModules(){
  var el=document.getElementById('krEdModules');
  if(!el)return;
  var c=window._edCourse;
  var html='';
  (c.modules||[]).forEach(function(mod,mi){
    var mPlans=mod.plans||[];
    var coursePlans=window._edCourse.plans||[];
    var effectivePlans=mPlans.length?mPlans:coursePlans;
    html+='<div class="kr-ed-module">'
      +'<div class="kr-ed-mod-header">'
        +'<input class="kr-ed-input sm" value="'+esc(mod.title)+'" onchange="window._edCourse.modules['+mi+'].title=this.value" placeholder="Modulname">'
        +'<button class="kr-ed-rm" onclick="window._edCourse.modules.splice('+mi+',1);renderEditorModules();">✕</button>'
      +'</div>'
      +'<div style="display:flex;gap:6px;flex-wrap:wrap;margin:0 0 8px;align-items:center;">'
        +'<span style="font-size:10px;color:var(--text-faint);font-weight:600;">Zugang:</span>'
        +['free','basic','member','pro','scale'].map(function(p){return '<label style="font-size:10px;color:var(--text-dim);display:flex;align-items:center;gap:2px;"><input type="checkbox" data-mi="'+mi+'" data-plan="'+p+'" class="kr-mod-plan-cb" '+(effectivePlans.includes(p)?'checked':'')+' onchange="htmEdModPlan('+mi+')"> '+p+'</label>';}).join('')
      +'</div>';
    (mod.lessons||[]).forEach(function(les,li){
      html+='<div class="kr-ed-lesson">'
        +'<input class="kr-ed-input sm" value="'+esc(les.title)+'" onchange="window._edCourse.modules['+mi+'].lessons['+li+'].title=this.value" placeholder="Lektionstitel">'
        +'<input class="kr-ed-input sm" value="'+esc(les.videoUrl||'')+'" onchange="window._edCourse.modules['+mi+'].lessons['+li+'].videoUrl=this.value" placeholder="Video URL">'
        +'<input class="kr-ed-input xs" type="number" value="'+(les.duration||0)+'" onchange="window._edCourse.modules['+mi+'].lessons['+li+'].duration=parseInt(this.value)||0" placeholder="Sek">'
        +'<button class="kr-ed-rm" onclick="window._edCourse.modules['+mi+'].lessons.splice('+li+',1);renderEditorModules();">✕</button>'
      +'</div>';
    });
    html+='<button class="kr-ed-add-les" onclick="window._edCourse.modules['+mi+'].lessons.push({id:\'\',title:\'\',videoUrl:\'\',duration:0});renderEditorModules();">+ Lektion</button>'
    +'</div>';
  });
  el.innerHTML=html;
}

window.htmEdModPlan=function(mi){
  var plans=[];
  document.querySelectorAll('.kr-mod-plan-cb').forEach(function(cb){
    if(parseInt(cb.dataset.mi)===mi&&cb.checked)plans.push(cb.dataset.plan);
  });
  window._edCourse.modules[mi].plans=plans;
};
window.htmEdAddModule=function(){
  window._edCourse.modules=window._edCourse.modules||[];
  window._edCourse.modules.push({id:'',title:'',lessons:[]});
  renderEditorModules();
};

window.htmEdSave=function(){
  var c=window._edCourse;
  c.id=document.getElementById('krEdId').value.trim().toLowerCase().replace(/[^a-z0-9-]/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
  c.title=document.getElementById('krEdTitle').value.trim();
  c.banner=document.getElementById('krEdBanner').value.trim()||'';
  c.icon=document.getElementById('krEdIcon').value.trim()||'';
  c.description=document.getElementById('krEdDesc').value.trim();
  c.plans=[];
  document.querySelectorAll('.kr-ed-plan-cb input:checked').forEach(function(cb){c.plans.push(cb.value);});
  if(!c.id||!c.title){alert('ID und Titel sind Pflichtfelder');return;}
  // Auto-generate module/lesson IDs
  (c.modules||[]).forEach(function(m){
    if(!m.id)m.id=m.title.toLowerCase().replace(/[^a-z0-9]/g,'-').slice(0,30)||'mod-'+Date.now();
    (m.lessons||[]).forEach(function(l){
      if(!l.id)l.id=l.title.toLowerCase().replace(/[^a-z0-9]/g,'-').slice(0,30)||'les-'+Date.now();
    });
  });
  api('course-admin-save',{course:c}).then(function(d){
    if(d.ok){_currentCourse=c;_initialized=false;init();}
    else{alert(d.error||'Fehler');}
  });
};

window.htmEdDelete=function(courseId){
  if(!confirm('Kurs "'+courseId+'" wirklich löschen?'))return;
  api('course-admin-delete',{courseId:courseId}).then(function(d){
    if(d.ok){_currentCourse=null;_initialized=false;init();}
  });
};

// ── LIFECYCLE ──
window.htmOnView_kurse=function(){_initialized=false;init();};
window.loadCourseList=loadCourseList;
window.renderCourseDetail=renderCourseDetail;
window.renderEditorModules=renderEditorModules;
})();
